import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ExtractionService {

  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) { }

  getFileLayoutsForDataExtraction() {
    return this.http.get<any[]>('api/dataExtraction/getFileLayoutsForDataExtraction');
  }

  getFieldsByBusinessProcessSpecificVersion(businessProcessId: number, businessProcessVersion: number) {
    return this.http.get<any[]>(`api/dataExtraction/getFieldsByBusinessProcessSpecificVersion/${businessProcessId}/${businessProcessVersion}`);
  }

  getBusinessProcessesForDataExtraction() {
    return this.http.get<any[]>('api/dataExtraction/getBusinessProcessesForDataExtraction');
  }

  getDataExtractionFileLayoutById(fileLayoutId: number) {
    return this.http.get<any>(`api/dataExtraction/getDataExtractionFileLayoutById/${fileLayoutId}`);
  }

  deleteDataExtractionFileLayout(fileLayout) {
    const options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: fileLayout,
    };
    return this.http.delete('api/dataExtraction/deleteDataExtractionFileLayout', options);
  }

  createDataExtractionFileLayout(fileLayout: any) {
    return this.http.post<number>('api/dataExtraction/createDataExtractionFileLayout', fileLayout);
  }

  updateDataExtractionFileLayout(fileLayout: any) {
    return this.http.put('api/dataExtraction/updateDataExtractionFileLayout', fileLayout);
  }

  createSchedulingWithDataExtractionDef(dataExtractionScheduling: any) {
    return this.http.post<number>('api/scheduling/createSchedulingWithDataExtractionDef', dataExtractionScheduling);
  }

  updateSchedulingWithDataExtractionDef(dataExtractionScheduling: any) {
    return this.http.put('api/scheduling/updateSchedulingWithDataExtractionDef', dataExtractionScheduling);
  }

  getAllDataExtractionScheduling() {
    return this.http.get<any[]>('api/scheduling/getAllDataExtractionScheduling');
  }

  deleteSchedulingWithDataExtractionDef(scheduling) {
    const options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: { schedulingInfo: scheduling.schedulingInfo, dataExtractionDefinition: scheduling.dataExtractionDefinition },
    };
    return this.http.delete('/api/scheduling/deleteSchedulingWithDataExtractionDef', options );
  }

  static fixDefinitionForSerialization(definition) {
    delete definition['extensionData'];
    delete definition['dataExtractionDefinition']['extensionData'];
    delete definition['schedulingInfo']['extensionData'];

    //Se não existe o id do file-layout, devemos remover a entidade para evitar erros de serialização
    if (definition.dataExtractionDefinition.fileLayout) {
      if (!definition.dataExtractionDefinition.fileLayout.fileLayoutId){
        definition.dataExtractionDefinition.fileLayout = null;
      } else {
        delete definition['dataExtractionDefinition']['fileLayout']['extensionData'];
        if (definition.dataExtractionDefinition.fileLayout.fieldColumns) {
          definition.dataExtractionDefinition.fileLayout.fieldColumns.forEach(item => {
            delete item['extensionData'];
          });
        }
      }
    }

    if (!definition.dataExtractionDefinition.retroactiveIntervalType){
      definition.dataExtractionDefinition.retroactiveIntervalType = 0;
    }

    // se o tipo de intervalo não é retroativo, limpo o valor do tempo - Retroactive = 3
    if (definition.dataExtractionDefinition.intervalType != 3)
    {
      definition.dataExtractionDefinition.intervalTimeAmount = null;
    }

    if (!definition.schedulingInfo.repetitionDuration) {
      definition.schedulingInfo.repetitionDuration = 0;
    }

    if (!definition.dataExtractionDefinition.description)
    {
      definition.dataExtractionDefinition.description = '';
    }

    return ({ dataExtractionDefinition: definition.dataExtractionDefinition, schedulingInfo: definition.schedulingInfo });
  }

  getAllDataExtractionDefinition() {
    return this.http.get('api/taskMonitoring/getAllDataExtractionDefinition');
  }

  pagedTasksSearch(filter) {
    return this.http.post<any>('api/taskMonitoring/pagedTasksSearch', filter);
  }

  downloadTaskDataExtraction(taskData) {
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/download');

    return this.http.get(`api/taskMonitoring/downloadTaskDataExtraction/${taskData}`,
      { headers: headers, responseType: 'blob' });
  }

}
